<span style="margin-left: 15px;">
  @if (timerPaused) {
    <i class="fa fa-play" (click)="startTimer()"></i>
  }
  @if (!timerPaused) {
    <i class="fa fa-pause" (click)="pauseTimer()"></i>
  }
  {{timeLeft | time}} until refresh
</span>